import {Grid,IconButton } from '@mui/material';
import RefreshIcon from "@mui/icons-material/Refresh";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: any) => ({
    iconButton: {
      color: "#2c3968",
      "&&.css-78trlr-MuiButtonBase-root-MuiIconButton-root": {
        padding: "0px",
        margin: "0px 35px 10px 0px",
      },
    },
    refreshIcon: {
      top: '10px',
      right:"30px",
      float: 'right',
      position:'relative'
    }
  }));

const RefreshIconComponent = (props:any) => {
    const classes = useStyles();
    const {onClick}=props;
    
    return (
        <Grid item xs={12}>
        <div className={classes.refreshIcon}>
          <IconButton
            title="Refresh"
            className={classes.iconButton}
            onClick={onClick}
          >
            <RefreshIcon />
          </IconButton>
        </div>
      </Grid>
    )
}

export default RefreshIconComponent;